import { trust, transparency, reliability } from '@/assets';

const Card = ({
  icon,
  title,
  content,
}: {
  icon: any;
  title: string;
  content: string;
}) => {
  return (
    <div>
      <div className='flex items-center mb-2'>
        <div className='p-2 mr-2 shadow-all-sides rounded-full'>
          <img className='h-6' alt='bill' src={icon} />
        </div>
        <h3 className=' font-medium text-md'>{title}</h3>
      </div>

      <div className='border-[1px] rounded-md mr:0 sm:mr-2 mb-4 sm:mb-0'>
        <p className='p-2 text-[12px]'>{content}</p>
      </div>
    </div>
  );
};

export const WhyUs = () => {
  return (
    <div className='px-8 mt-8 sm:mt-0 mb-8 sm:my-0 sm:p-8'>
      <h2 className='text-lg font-semibold text-center mb-8 text-transform: uppercase'>
        OUR CORE VALUES
      </h2>
      <p className='text-center mb-8'>
        At AWAP INVESTORS, we are guided by three core values that shape our
        approach to project and business:
      </p>

      <div className='flex flex-col sm:flex-row justify-between'>
        <Card
          title='TRUST'
          icon={trust}
          content='We prioritize building trust with our investors, partners, and Awap Project Unit (APU) holders. By being dependable and acting with integrity, we foster strong relationships and ensure a secure environment for project. Trust is the foundation of our business, and we work tirelessly to maintain it.'
        />
        <Card
          title='TRANSPARENCY'
          icon={transparency}
          content='Transparency is at the heart of our operations. We believe in open and honest communication, providing clear information about our projects, risks, and opportunities. By being transparent, we empower our investors to make informed decisions and build confidence in our services.'
        />
        <Card
          title='RELIABILITY'
          icon={reliability}
          content='Reliability is key to our success. We are committed to delivering on our promises and meeting our obligations. Whether its through consistent project performance, timely communication, or expert management, we strive to be reliable partners for our investors and Awap Project Unit (APU) holders.'
        />
      </div>
    </div>
  );
};
